export default __webpack_public_path__ + "assets/612b39.svg";